<template>
    <div>
        <div class="checkinout-header">
            <img class="checkinout-logo" src="/assets/layout/images/logo.svg" alt="ProAstra">
            <h1>
                <span>Scan asset</span>
            </h1>

        </div>
        <div class="checkinout-details">
            <div style="display:flex; flex-direction: column; justify-content: center;">
                <div>
                    <div v-if="NFCAvailable && nfcPermissionStatus != 'granted'">
                        <p>Please enable NFC scanning on your device.</p>
                        <Button style="margin-bottom: 1rem;" type="button" class="checkinout-submit" id="scanButton" label="Enable NFC Scanning" @click="NFCButtonVisible = true" />
                    </div>
                    <div v-else style="margin-bottom: 1rem;">
                        <!-- NFC scan -->
                        <p>Please tap an NFC</p>
                        <p>or</p>
                    </div>
                </div>
                <div>
                    <Button type="button" class="checkinout-submit" id="scanButton" label="Scan QR Code" @click.prevent="scanQR(false)" />
                </div>
            </div>
            <div id="render_wrapper">
                <!-- <i class="pi pi-times" :class="{ 'hidden': !showVideo }" style="font-size: 1.5rem"
                    @click.prevent="scanQR(true)"></i> -->
                <i class="pi pi-spin pi-spinner" :class="{ 'hidden': !showVideo }" style="font-size: 2rem"></i>
                <video :class="{ 'hidden': !showVideo }" id="render"></video>
            </div>
        </div>
        <Toast />
    </div>
</template>

<script>
import QrScanner from 'qr-scanner'; // if installed via package and bundling with a module bundler like webpack or rollup

export default {
    data() {
        return {
            NFCAvailable: false,
            NFCMessage: null,
            NFCButtonVisible: true,
            nfcPermissionStatus: null,
            showVideo: false,
            QRResult: null,
        }
    },
    props: ['isOnline'],
    created() {
        this.NFCPermission();
        const qrScanner = new QrScanner(
            videoElem,
            result => {
                this.QRResult = result.data;
                this.$router.replace({ path: this.QRResult }) // absolute url at the moment set in /assets and /asset
                this.showVideo = false;
                qrScanner.stop();
            },
            {
                preferredCamera: 'environment',
                highlightScanRegion: false
            },
        );
    },
    methods: {
        async NFCPermission() {
            // if browser supports Web NFC (android only @ 09/06/2023)
            if ('NDEFReader' in window) {

                this.NFCAvailable = true;
                const nfcPermissionStatus = await navigator.permissions.query({ name: "nfc" });
                this.nfcPermissionStatus = nfcPermissionStatus.state;

                if (nfcPermissionStatus.state === "granted") {
                    // NFC access was previously granted, so we can start NFC scanning now.
                    this.readNFC();
                } else {
                    // Show a "scan" button.
                    document.querySelector("#scanButton").onclick = event => {
                        // triggers nfc prompt on device here, then runs readNFC()
                        this.readNFC();
                    };
                }
            } else {
                // console.log('NFC not available');
                this.NFCAvailable = false;
                return;
            }
        },
        async readNFC() {
            const ndef = new NDEFReader();
            // scan is required to be asyncronous, as permission needs to be granted
            await ndef.scan().then(() => {
                ndef.onreading = event => {
                    console.log("NDEF message read:", event);
                    const message = event.message;
                    for (const record of message.records) {
                        console.log(record);
                        switch (record.recordType) {
                            case "text":
                                const textDecoder = new TextDecoder(record.encoding);
                                this.NFCMessage = textDecoder.decode(record.data);
                                this.$router.replace({ path: this.NFCMessage })
                                break;
                            default:
                            // if left blank, site only supports text-only NFCs, feel free to add cases as necessary
                        }
                    }
                };
                ndef.onreadingerror = () => {
                    console.log("Cannot read data from the NFC tag. Try another one?");
                };
            }).catch(error => {
                console.log(`Error! Scan failed to start: ${error}.`);
            });
        },
        scanQR(destroy) {
            if (!destroy) {
                this.showVideo = true;
            }
            const videoElem = document.querySelector('#render');

            const qrScanner = new QrScanner(
                videoElem,
                result => {
                    this.QRResult = result.data;
                    let url, path;

                    try { // if url is absolute
                        url = new URL(this.QRResult);
                        path = url.pathname;
                    } catch (_) { // if url is relative
                        path = this.QRResult
                    }
                    
                    this.$router.replace({ path: path })
                    this.showVideo = false;
                    qrScanner.stop();
                },
                {
                    preferredCamera: 'environment',
                    highlightScanRegion: true
                },
            );

            if (!qrScanner.result) {
                qrScanner.start();
            } else {
                qrScanner.destroy();
            }
            if (destroy) {
                this.showVideo = false;
                qrScanner.stop();
            }

        }
    }
}
</script>

<style scoped lang="scss">
#render_wrapper {
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr;
    place-items: center;
    position: relative;

    i {
        grid-row-start: 1;
        grid-column-start: 1;

        &.hidden {
            display: none;
        }

        &.pi-times {
            color: white;
            text-shadow: 0 0 3px black;
            position: absolute;
            top: 25px;
            left: 15px;
            z-index: 2;
        }
    }

    video {
        margin: 0 auto;
        border: 3px solid #0d89ec;
        border-radius: 3px;
        margin-top: 1rem;
        max-width: 100%;
        width: 100%;
        grid-row-start: 1;
        grid-column-start: 1;

        &.hidden {
            display: none;
        }
    }
}
</style>